import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const createProductStart = () => {
    return {
        type: actionTypes.CREATE_PRODUCT_START
    }
}

export const createProductSuccess = (successMessage) => {
    return {
        type: actionTypes.CREATE_PRODUCT_SUCCESS,
        message: successMessage
    }
}

export const createProductFail = (errorMessage) => {
    return {
        type: actionTypes.CREATE_PRODUCT_FAIL,
        error: errorMessage
    }
}

export const createProduct = (pname, token) => {
    return async dispatch => {
        dispatch(createProductStart());
        let url = `${api}/products`;
        const options = {
            url: url,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {
                name: pname
            }
        };
        await axios(options)
            .then(response => {
                dispatch(createProductSuccess('Product Creation Success'));
                dispatch(getProduct(token));
            })
            .catch(err => {
                dispatch(createProductFail('Product Creation Failed'));
            });
    }
}

export const getProductStart=()=>{
    return {
        type:actionTypes.GET_PRODUCT_START
    }
}

export const getProductSuccess=(allProducts)=>{
    return {
        type:actionTypes.GET_PRODUCT_SUCCESS,
        products:allProducts,
    }
}

export const getProductFail=(errorMessage)=>{
    return {
        type:actionTypes.GET_PRODUCT_FAIL,
        error:errorMessage
    }
}

export const getProduct=(token)=>{
    return async dispatch=>{
        dispatch(getProductStart());
        let url = `${api}/products`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {}
        };
        await axios(options)
            .then(response => {
                dispatch(getProductSuccess(response.data));
            })
            .catch(err => {
                dispatch(getProductFail(`get product failed - ${err}`));
            });
    }
}

export const openProductEditForm=(edproduct)=>{
    return {
        type:actionTypes.OPEN_PRODUCT_EDIT_FORM,
        product:edproduct,
    }
}

export const closeProductEditForm=()=>{
    return {
        type:actionTypes.CLOSE_PRODUCT_EDIT_FORM
    }
}

export const updateProductStart=()=>{
    return {
        type:actionTypes.UPDATE_PRODUCT_START
    }
}

export const updateProductSuccess=(successMessage)=>{
    return {
        type:actionTypes.UPDATE_PRODUCT_SUCCESS,
        message:successMessage
    }
}

export const updateProductFail=(errorMessage)=>{
    return {
        type:actionTypes.UPDATE_PRODUCT_FAIL,
        error:errorMessage
    }
}

export const updateProduct=(product,token)=>{
    return async dispatch=>{
        dispatch(updateProductStart());
        let url = `${api}/products/${product.id}`;
        const options = {
            url: url,
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {name:product.name}
        };
        await axios(options)
            .then(response => {
                dispatch(updateProductSuccess('update product success'));
                dispatch(getProduct(token));
            })
            .catch(err => {
                dispatch(updateProductFail(`update product failed - ${err}`));
            });
    }
}

export const clearProductEdit=()=>{
    return {
        type:actionTypes.CLEAR_PRODUCT_EDIT
    }
}

export const deleteProductStart=()=>{
    return {
        type:actionTypes.DELETE_PRODUCT_START
    }
}

export const deleteProductSuccess=(successMessage)=>{
    return {
        type:actionTypes.DELETE_PRODUCT_SUCCESS,
        message:successMessage
    }
}

export const deleteProductFail=(errorMessage)=>{
    return {
        type:actionTypes.DELETE_PRODUCT_FAIL,
        error:errorMessage
    }
}

export const deleteProduct=(id,token)=>{
    return async dispatch=>{
        dispatch(deleteProductStart());
        let url = `${api}/products/${id}`;
        const options = {
            url: url,
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: {}
        };
        await axios(options)
            .then(response => {
                dispatch(deleteProductSuccess('delete product success'));
                dispatch(getProduct(token));
            })
            .catch(err => {
                dispatch(deleteProductFail(`delete product failed - ${err}`));
            });
    }
}